import { useState } from 'react'
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../shared/utils/CustomPagination';
import { Typography } from '@mui/material';

const AssignFacilityTable = ({ facilityRow, isLoading }) => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const facilityColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "facility_name",
            headerName: "Facility Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "is_available",
            headerName: "Available",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        }
    ]
    return (
        <>

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={facilityRow}
                    columns={facilityColumns}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={facilityRow?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}
        </>
    )
}

export default AssignFacilityTable